"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const first_1 = __importDefault(require("lodash/first"));
const last_1 = __importDefault(require("lodash/last"));
const moment_1 = __importDefault(require("moment"));
/**
 * For formatting date/time from PDF
 * @param strings Such as ["12:00", "12:15 PM"]
 * @param dateString Such as "08/02/2022"
 * @returns Unix millisecond timestamp
 */
function timestampFromArrayOfTimeStrings(strings, dateString) {
    // e.g. 12:00 - 12:15 PM
    // Note that both times are PM in this case, not just the second time
    // 11:45 - 12:30 PM
    // Note that the first case is AM
    const format = 'MM-DD-YYYY hh:mm A';
    const timeStrings = strings.map(string => string.trim()); // e.g. ['11:45', '12:30 PM']
    const firstMomentAm = (0, moment_1.default)(`${dateString} ${(0, first_1.default)(timeStrings)} AM`, format);
    const firstMomentPm = (0, moment_1.default)(`${dateString} ${(0, first_1.default)(timeStrings)} PM`, format);
    const secondMoment = (0, moment_1.default)(`${dateString} ${(0, last_1.default)(timeStrings)}`, format);
    const firstMoment = firstMomentPm.isBefore(secondMoment) ? firstMomentPm : firstMomentAm;
    const firstTimestamp = firstMoment.valueOf();
    return firstTimestamp;
}
exports.default = timestampFromArrayOfTimeStrings;
